import {
  postBackendDownloadCancelDownload,
  postBackendDownloadGetDownloadList,
} from '@/services/yizhe-web/gonggongfenlei';
import { ProTable } from '@ant-design/pro-components';
import { message, Modal, Progress } from 'antd';
export const showModalCommonExport = () => {
  // 取消导出
  const handleCancelExport = (record: any) => {
    Modal.confirm({
      title: '取消导出',
      content: '确定取消导出？',
      onOk: async () => {
        const { code } = await postBackendDownloadCancelDownload({ id: record.id });
        if (code === '200') {
          message.success('取消成功');
        }
      },
    });
  };

  // 确定导出
  const handleOkExport = (record: any) => {
    window.open(record.file_url);
  };

  const columns = [
    {
      title: '导出内容',
      dataIndex: 'title',
      key: 'title',
      align: 'center' as 'center',
    },
    {
      title: '筛选时间',
      dataIndex: 'time_range',
      key: 'time_range',
      align: 'center' as 'center',
    },
    {
      title: '状态',
      dataIndex: 'down_status',
      key: 'down_status',
      width: 140,
      align: 'center' as 'center',
      render: (_: any, record: any) => {
        return (
          <>
            {record.down_status === 0 ? (
              <Progress percent={+record.progress} status="active" />
            ) : (
              <span>{record.down_status_desc}</span>
            )}
          </>
        );
      },
    },
    {
      title: '操作时间',
      dataIndex: 'created_at',
      key: 'created_at',
      align: 'center' as 'center',
    },
    {
      title: '操作',
      dataIndex: 'option',
      key: 'option',
      align: 'center' as 'center',
      render: (_: any, record: any) => {
        return (
          <>
            {record.down_status === 0 ? (
              <a
                onClick={() => {
                  handleCancelExport(record);
                }}
              >
                取消导出
              </a>
            ) : null}
            {record.can_download === 1 ? (
              <a
                onClick={() => {
                  handleOkExport(record);
                }}
              >
                下载
              </a>
            ) : null}
          </>
        );
      },
    },
  ];

  Modal.success({
    icon: null,
    title: '导出中心',
    width: 800,
    closable: true,
    okText: '关闭',
    okButtonProps: { type: 'default' },
    autoFocusButton: null,
    content: (
      <>
        <ProTable<NonNullable<API.GetDownloadListResult['data']['list']>>
          columns={columns}
          polling={2000}
          search={false}
          toolBarRender={false}
          rowKey="id"
          request={async (params) => {
            const { data }: any = await postBackendDownloadGetDownloadList({
              ...params,
              page: params?.current,
            });
            return {
              data: data?.list,
              total: data?.total,
            };
          }}
          bordered
          pagination={{
            defaultPageSize: 10,
          }}
        />
      </>
    ),
  });
};
